
import { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';

export default function PaymentSuccessPage() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');
  const [loading, setLoading] = useState(true);
  const [paymentDetails, setPaymentDetails] = useState<any>(null);

  useEffect(() => {
    if (sessionId) {
      // In a real implementation, you would verify the session with Stripe
      // For now, we'll just show a success message
      setTimeout(() => {
        setPaymentDetails({
          amount: 'Payment processed successfully',
          status: 'completed'
        });
        setLoading(false);
      }, 1000);
    } else {
      setLoading(false);
    }
  }, [sessionId]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-emerald-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Processing your payment...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-20">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg shadow-lg p-8 text-center">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-check-line text-2xl text-green-600"></i>
          </div>
          
          <h1 className="text-3xl font-bold text-gray-900 mb-4">Payment Successful!</h1>
          
          <p className="text-lg text-gray-600 mb-8">
            Thank you for your payment. Your transaction has been processed successfully.
          </p>

          {sessionId && (
            <div className="bg-gray-50 rounded-lg p-4 mb-8">
              <p className="text-sm text-gray-600">
                <strong>Transaction ID:</strong> {sessionId}
              </p>
            </div>
          )}

          <div className="space-y-4">
            <p className="text-gray-600">
              You will receive a confirmation email shortly with your payment details and next steps.
            </p>
            
            <p className="text-gray-600">
              Our team will contact you within 24 hours to discuss your investment or booking details.
            </p>
          </div>

          <div className="mt-8 space-y-4">
            <Link
              to="/"
              className="inline-block bg-emerald-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              Return to Home
            </Link>
            
            <div className="text-center">
              <Link
                to="/contact"
                className="text-emerald-600 hover:text-emerald-700 font-medium cursor-pointer"
              >
                Contact Us for Questions
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
